var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkEnv)?_c('div',{staticClass:"staging-env-label"},[_vm._v(" "+_vm._s(_vm.envName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }